import { T } from '../../styles/theme'

const VARIANTS = {
  primary: { background: T.accent, color: '#000', border: 'none' },
  soft: { background: T.accentSoft, color: T.accent, border: `1px solid ${T.accent}` },
  ghost: { background: 'transparent', color: T.muted, border: `1px solid ${T.cardB}` },
  danger: { background: T.danger, color: '#fff', border: 'none' },
  dangerSoft: { background: 'rgba(248,113,113,0.1)', color: T.danger, border: `1px solid ${T.danger}` },
}

export default function Button({ variant = 'primary', disabled, fullWidth = true, style, children, ...props }) {
  const v = VARIANTS[variant] ?? VARIANTS.primary
  return (
    <button
      disabled={disabled}
      style={{
        width: fullWidth ? '100%' : undefined,
        padding: 14, borderRadius: 14, fontSize: 15, fontWeight: 700,
        fontFamily: 'DM Sans, sans-serif', cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        ...v,
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  )
}
